module.exports = __webpack_public_path__ + "files/cbae4a4b293b43f958881d1f6c80af07.png";